import React, { useState } from "react";
import "./Options.css";
import {
  undo,
  redo,
  info,
  CreditBtnIcon,
  SyncNav,
} from "../../../assets/icons";
import { RoleName, NameOnly, Songs, Logos, Blurb } from "./OptionBlocks";
import { useSelector, useDispatch } from "react-redux";
import {
  redoOptions,
  saveProjectGlobalOption,
  undoOptions,
  updateProjectCredits,
  updateProjectCreditsByGoogle,
} from "../../../Redux/actions/projectActions";
import OptionFont from "./OptionFont/OptionFont";
import { selectedOption } from "../../../Redux/actions/projectActions";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ScreenOption from "../Cards/components/ScreenOption";
// import Button from "../../../Components/Button/Button_2";
import { toast } from "react-toastify";
import CustomToast, {
  customToatStyle,
  customToatStyleError,
} from "../../../Components/CustomToast/CustomToast";
import { read, utils } from "xlsx";
import { excelDataToCredits } from "../../../services/excelDataToProjectData";
import { Button } from "../../../Components";
import { AiOutlineGlobal } from "react-icons/ai";
import RenderNew from "../Render/RenderNew";
import CardRender from "../Cards/CardRender";
import { selectedPageOption } from "../../../Redux/actions/commonActtion";
import ScrollRender from "../Render/June2026/scroll/ScrollRender";
import CardRender2 from "../Render/June2026/card/CardRender";

const getBlockName = (blockType) => {
  switch (blockType?.toLowerCase()) {
    case "rolename":
      return "Role + Name";
    case "nameonly":
      return "Name Only";
    case "logo":
      return "Logos";
    case "blurb":
      return "Blurb";
    case "song":
      return "Songs";
    default:
      return "Name Only";
  }
};

const getOptionBlock = (
  options,
  currentBlockIdx,
  currentBlockId,
  undoStack,
  setReLoading,
  isCard,
) => {
  switch (options.block_type?.toLowerCase()) {
    case "rolename":
      return (
        <RoleName
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          undoStack={undoStack}
          isCard={isCard === undefined || !isCard ? false : true}
        />
      );
    case "nameonly":
      return (
        <NameOnly
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          undoStack={undoStack}
          isCard={isCard === undefined || !isCard ? false : true}
        />
      );
    case "logo":
      return (
        <Logos
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          undoStack={undoStack}
          setReLoading={setReLoading}
          isCard={isCard === undefined || !isCard ? false : true}
        />
      );
    case "blurb":
      return (
        <Blurb
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          undoStack={undoStack}
          isCard={isCard === undefined || !isCard ? false : true}
        />
      );
    case "song":
      return (
        <Songs
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          undoStack={undoStack}
          isCard={isCard === undefined || !isCard ? false : true}
        />
      );
    default:
      return (
        <NameOnly
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          undoStack={undoStack}
          isCard={isCard === undefined || !isCard ? false : true}
        />
      );
  }
};

const getUpdatedProjectCredits = (currentCredits, newCredits) => {
  try {
    const updatedCredits = newCredits;
    for (let i = 0; i < newCredits.length; i++) {
      let idx = currentCredits.findIndex(
        (credit) =>
          credit.options.block_name == newCredits[i].options.block_name,
      );
      if (
        idx !== -1 &&
        currentCredits[idx].options.block_type ==
          newCredits[i].options.block_type
      ) {
        updatedCredits[i].options = currentCredits[idx].options;
      }
    }
    return { data: updatedCredits };
  } catch (error) {
    return { error, data: null };
  }
};

const Options = ({
  currentBlockOptions,
  currentBlockIdx,
  currentBlockId,
  setReLoading,
  isOptionSelected,
  isCard,
  setIsRenderExport,
  isRenderExport,
}) => {
  const [selected, setSelected] = useState("options");
  const [blockName, setBlockName] = useState(currentBlockOptions.block_type);
  const objectMap = useSelector((state) => state.undoRedo);
  const undoStack = objectMap[currentBlockIdx]?.obj;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { projectId } = useParams();
  const id = "66e14a11eedf1bfc39f94b39";
  const location = useLocation();
  let { isDashboard } = location?.state;
  const isRenderPage = location.pathname.endsWith("/render");
  const editorPath = isCard
    ? `/dashboard/card/${projectId}`
    : `/dashboard/scroll/${projectId}`;
  const renderPath = `${editorPath}/render`;

  const setRenderOpen = (open) => {
    navigate(open ? renderPath : editorPath, {
      state: {
        isDashboard: isDashboard,
        isRender: Boolean(open),
        projectId: projectId,
        isCard: Boolean(isCard),
      },
    });
  };

  const OptionHandler = (val) => {
    dispatch(selectedOption(val));
  };

  const {
    googleSheetLink,
    _id,
    googleSpreadSheetId,
    credits: currentCredits,
    currentBlock,
  } = useSelector((state) => state?.project);

  const handleGoogleUpdate = async () => {
    await setReLoading({ condn: true, label: "Syncing..." });

    try {
      const res = await dispatch(
        updateProjectCreditsByGoogle(
          _id,
          googleSpreadSheetId,
          currentCredits,
          isCard,
        ),
      );
      if (res?.success === true) {
        await setReLoading({ condn: false, label: "" });
        setTimeout(() => {
          toast(
            <CustomToast title="" content={res?.message} />,
            customToatStyle,
          );
        }, 300);
      } else {
        await setReLoading({ condn: false, label: "" });
        setTimeout(() => {
          toast(
            <CustomToast
              isError
              title={res?.response?.data?.title || "Error"}
              content={res?.response?.data?.message}
            />,
            customToatStyleError,
          );
        }, 2000);
      }
    } catch (err) {
      await setReLoading({ condn: false, label: "" });
    }
  };

  const handleFileInput = (file) => {
    try {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const binaryStr = evt.target.result;
        const wb = read(binaryStr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const jsonData = utils.sheet_to_json(ws, { header: 1 });
        const newCredits = excelDataToCredits(jsonData);
        const { data: updatedCredits, error } = getUpdatedProjectCredits(
          currentCredits,
          newCredits,
        );
        if (error) {
          return error;
        }
        dispatch(updateProjectCredits(_id, updatedCredits));
      };
      reader.readAsBinaryString(file);
    } catch (err) {
      return err;
    }
  };

  // Function to apply settings to all scroll
  const applyToAll = () => {
    dispatch(
      saveProjectGlobalOption(
        currentBlockId,
        currentBlockOptions,
        currentBlockOptions.block_type,
        isCard,
      ),
    );
    toast(
      <CustomToast
        title=""
        content={`Changes applied to all ${currentBlockOptions.block_type} blocks.`}
      />,
      customToatStyle,
    );
  };

  const OptionHandlerRender = (val) => {
    dispatch(selectedPageOption(val, _id, isCard));
    setRenderOpen(true);
  };

  return (
    <div className="OptionContainer">
      <div className="optionHdr">
        <div className="Layout">
          <div className="Layout-title">
            <div className={isCard ? `Layout-titleBlkCrd` : `Layout-titleBlk`}>
              <div
                className={
                  "layout-text " + (selected === "options" ? "selected" : "")
                }
                onClick={() => {
                  setSelected("options");
                  OptionHandler("layout");
                }}
              >
                Layout
              </div>

              <div
                className={
                  "layout-text " + (selected === "fonts" ? "selected" : "")
                }
                onClick={() => {
                  setSelected("fonts");
                  OptionHandler("font");
                }}
              >
                Font
              </div>

              {isCard && (
                <div
                  className={
                    "layout-text " + (selected === "screen" ? "selected" : "")
                  }
                  onClick={() => {
                    setSelected("screen");
                    OptionHandler("screen");
                  }}
                >
                  Screen
                </div>
              )}
            </div>

            {/* <div className="undo-redo">{objectMap[currentBlockIdx]?.obj && (
              <><button disabled={undoStack.getPosition < 1} onClick={() => dispatch(undoOptions(currentBlockId))}><img src={undo} alt="" /></button>
                <button disabled={ undoStack.getPosition === -1 || undoStack.getPosition === undoStack.getData.length - 1} onClick={() => dispatch(redoOptions(currentBlockId))}>
                  <img src={redo} alt="" style={{ color: "white" }} />
                </button></>)}
            </div> */}
          </div>

          <div className="Layout-screen">
            {selected === "options" ? (
              <div className="Mainlayout-screen">
                <div className="Block-type border-[#ffffff0e] border-b-[1px]">
                  {selected !== "screen" && (
                    <div className=" inline-block group Block-text cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4 text-white ">
                      <span className="cursor-help">Block type</span>
                      <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px] p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
                        The format structure for this credit block (e.g., Role +
                        Name).
                      </span>
                    </div>
                  )}
                  <div
                    className={
                      selected === "screen" ? "crdBlock-name" : "Block-name"
                    }
                  >
                    {selected !== "screen" && (
                      <div
                        className={{
                          marginLeft: selected === "fonts" ? "10px" : "",
                        }}
                      >
                        <span>
                          {getBlockName(currentBlockOptions.block_type)}
                        </span>
                      </div>
                    )}
                    {selected === "screen" && (
                      <div className="">
                        <p>Card {currentBlockIdx + 1}</p>
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  {getOptionBlock(
                    currentBlockOptions,
                    currentBlockIdx,
                    currentBlockId,
                    undoStack,
                    setReLoading,
                    isCard,
                  )}
                </div>

                <div className="mt-[6px] py-[11px] px-[14px] rounded-xl flex justify-between items-center  border-[1px] border-[#7c5cff2e] bg-[#7c5cff14]">
                  <div className="font-body text-[13px] text-[#f0eeff]  font-medium">
                    Global Settings
                  </div>
                  <div className="">
                    <button onClick={applyToAll} className="global-btn ">
                      <AiOutlineGlobal className="text-[1rem]" />
                      Apply to all
                    </button>
                  </div>
                </div>
              </div>
            ) : selected === "screen" ? (
              <div className="Mainlayout-screen">
                <ScreenOption
                  currentBlockOptions={currentBlockOptions}
                  currentBlockIdx={currentBlockIdx}
                  currentBlockId={currentBlockId}
                  isCard={isCard}
                />
              </div>
            ) : (
              <div className="Mainlayout-screen">
                <OptionFont isCard={isCard} />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className=" optionFtr flex items-center gap-2 w-full border-t-[1px] border-[#ffffff0e] pt-2">
        <div
          className="Credit-btn w-1/2"
          onClick={() => window.open(googleSheetLink)}
        >
          <img
            className="w-[15px] h-[15px] text-white"
            src={CreditBtnIcon}
            alt=""
          />
          <span className=" text-[13px] text-white font-[650]">
            Credit Sheet
          </span>
        </div>

        {googleSheetLink ? (
          <div
            className="Credit-btn w-1/2 font-medium"
            onClick={handleGoogleUpdate}
          >
            <img className="w-[15px] h-[15px]" src={SyncNav} alt="" />
            <span className="text-[13px] text-white font-[650]">
              Sync Credits
            </span>
          </div>
        ) : (
          <div className="Credit-btn w-1/2" handleFileInput={handleFileInput}>
            <img className="w-[15px] h-[15px]" src={SyncNav} alt="" />
            <span className="text-[13px] text-white font-[650]">
              Sync Credits
            </span>
          </div>
        )}
      </div>
      <div
        className="optionFtr"
        onClick={() => {
          setRenderOpen(true);
          OptionHandlerRender("renderPage");
        }}
      >
        <div className="OptionRender-btn">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2.2}
            strokeLinecap="round"
            strokeLinejoin="round"
            width={24}
            height={24}
          >
            <polygon points="23 7 16 12 23 17 23 7" />
            <rect x="1" y="5" width="15" height="14" rx="2" />
          </svg>
          <span className="">Render</span>
        </div>

        {/* {renderOpen && !isCard && (
        <RenderNew
          renderOpen={renderOpen}
          setRenderOpen={setRenderOpen}
          currentBlockIdx={currentBlock?.idx}
          isRenderExport={isRenderExport}
          setIsRenderExport={setIsRenderExport}
        />
      )} */}

        {isRenderPage && !isCard && (
          <ScrollRender
            renderOpen={isRenderPage}
            setRenderOpen={setRenderOpen}
            currentBlockIdx={currentBlock?.idx}
            isRenderExport={isRenderExport}
            setIsRenderExport={setIsRenderExport}
          />
        )}

        {/* {renderOpen && isCard && (
        <CardRender
          renderOpen={renderOpen}
          setRenderOpen={setRenderOpen}
          currentBlockIdx={currentBlock?.idx}
          isRenderExport={isRenderExport}
          setIsRenderExport={setIsRenderExport}
          isCard={isCard}
        />
      )} */}

        {isRenderPage && isCard && (
          <CardRender2
            renderOpen={isRenderPage}
            setRenderOpen={setRenderOpen}
            currentBlockIdx={currentBlock?.idx}
            isRenderExport={isRenderExport}
            setIsRenderExport={setIsRenderExport}
            isCard={isCard}
          />
        )}
      </div>
    </div>
  );
};

export default Options;
